// Third-party

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { classNames } from '@/utils';

import type { SocialInboxType } from '@/components/pages/conversations/SocialInbox/types';

// Constants/Libs/Types
import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import Icon from '@/components/base/Icon';

interface SocialInboxTypeTitleProps {
    selected?: boolean;
    type: SocialInboxType;
    className?: string;
}

export const SocialInboxTypeTitle = ({
    selected = false,
    type,
    className
}: SocialInboxTypeTitleProps) => {
    const { t } = useTranslation('conversations');

    return (
        <div className={classNames('flex items-center gap-2 text-xs', className)}>
            <Icon
                icon={selected ? SOCIAL_INBOX_META[type].activeIcon : SOCIAL_INBOX_META[type].icon}
            />
            <span>{t(`tabs.${type}`)}</span>
        </div>
    );
};
